import React from 'react';
import { Navigate } from 'react-router-dom';
import { authStore } from '../../stores/authStore';

const PermissionRoute = ({ children, module, action }) => {
  const { hasPermission } = authStore();

  if (!hasPermission(module, action)) {
    return <Navigate to="/acesso-negado" replace />;
  }

  return children;
};

export default PermissionRoute;